import { Button, Drawer, Group, Icon, Tag, Text, Title } from "components/common"
import { useEffect, useImperativeHandle, useMemo, useState } from "react"

import { DATE_FORMAT } from "constants"
import Space from "components/common/space/space"
import TsrComponent from "./tsrComponent/tsrComponent"
import dayjs from "dayjs"
import { useLazyGetClientDetailQuery } from "features/clients/detail/api"
import theme from "utils/themeVars"
import { useSearchParams } from "react-router-dom"
import { t } from "i18next"
import { dateTimeFunction } from "utils/date"
import { localisedValue } from "utils"
import { DATE_TIME_FORMAT } from "constants"

const TsrDrawer = ({ lead, setLead = () => {}, params, totalLeads, page = 0, pageLimit = 10, refs }) => {
  const [open, setOpen] = useState(false)
  const [searchParams, setSearchParams] = useSearchParams()
  const [leads, setLeads] = useState()
  const [activeKey, setActiveKey] = useState("tasks")
  const [buttonText, setButtonText] = useState()
  const [isFromAction, setIsFromAction] = useState()
  const [getClientDetail, { data: client, isFetching: isClientFetching, isUninitialized: isGetClientUninitialized }] =
    useLazyGetClientDetailQuery()

  const availablePages = useMemo(() => {
    if (totalLeads) {
      return Math.ceil(totalLeads / pageLimit)
    }
  }, [totalLeads, pageLimit])

  useImperativeHandle(refs, () => {
    return {
      showLeadDetail: (leadsData, activeTab, openAddTask) => {
        setActiveKey(activeTab)
        setButtonText(openAddTask ? "Back" : "Add Task")
        setIsFromAction(openAddTask ? true : false)
        if (leadsData?.length) {
          setOpen(true)
          setLeads(leadsData)
        }
      },
      isDrawerOpen: () => {
        return open
      },
      closeDrawer: () => {
        setOpen(false)
      },
    }
  })

  useEffect(() => {
    open && lead && getClientDetail(lead?.lead?.Client?.id)
  }, [lead, open])

  const removeClass = () => {
    if (document?.body?.classList?.contains?.("bg-salmon")) {
      document?.body?.classList?.remove?.("bodyScroll")
    }
  }

  useEffect(() => {
    open ? document?.body?.classList?.add?.(["bodyScroll"]) : removeClass()
    return () => {
      removeClass()
    }
  }, [open])

  const onBackClick = () => {
    if (!!leads[lead?.index - 1]) {
      setLead({ lead: leads[lead?.index - 1], index: lead?.index - 1 })
    } else if (!page == 0 || !availablePages == 0) {
      setSearchParams({ ...params, page: parseInt(page) - 1 })
    }
  }
  const onNextClick = () => {
    if (!!leads[lead?.index + 1]) {
      setLead({ lead: leads?.[lead?.index + 1], index: lead?.index + 1 })
    } else if (!availablePages == 0 && page < availablePages - 1) {
      setSearchParams({ ...params, page: parseInt(page) + 1 })
    }
  }
  const getColor = () => {
    if (dayjs().isAfter(lead?.lead?.nextStatusDeadline)) {
      return theme["error-color"]
    }
    return theme["primary-color"]
  }

  return (
    <Drawer
      title={
        <>
          <Group template="1fr auto">
            <div>
              {lead?.lead?.nextStatusTitle && (
                <Tag
                  color={getColor()}
                  children={`${t("TODO")}: ${localisedValue({
                    object: lead?.lead,
                    key: "nextStatusTitle",
                  })} - ${t("Deadline")}: ${
                    lead?.lead?.nextTaskDate
                      ? dateTimeFunction({
                          date: lead?.lead?.nextTaskDate,
                          format: DATE_TIME_FORMAT,
                        })
                      : "-"
                  }`}
                />
              )}
              <Title level={3} className="mbe-0">
                {localisedValue({ object: lead?.lead?.Client, key: "name" }) ||
                  localisedValue({ object: client, key: "name" })}
              </Title>
              <Space align="start" style={{ color: "#9d9d9d" }} className="bulletSpacer fs12 fw-normal">
                {client && localisedValue({ object: client?.City, key: "name" })}
                {client && <Icon icon="GoDotFill" size=".7em" color="#D6D6D6" />}
                {client && dateTimeFunction({ date: client?.createdAt })}
              </Space>
              {localisedValue({ object: client?.ClientSource, key: "name" }) && (
                <Text type="secondaryLight" className="fs12">
                  <span className="pi-8">|</span>
                  <span>
                    {t("Source")}: {localisedValue({ object: client?.ClientSource, key: "name" })}{" "}
                  </span>
                </Text>
              )}
            </div>
            <Space style={{ marginInlineEnd: 8 }}>
              <Button
                disabled={(page == 0 || availablePages == 0) && !!lead?.index == 0}
                icon={"IoIosArrowBack"}
                onClick={onBackClick}
                style={{ "--btn-color": "#A7A7A7", "--flip-icon": "scaleX(-1)" }}
              />
              <Button
                disabled={page == availablePages - 1 && !!(lead?.index == leads?.length - 1)}
                icon={"IoIosArrowForward"}
                onClick={onNextClick}
                style={{ "--btn-color": "#A7A7A7", "--flip-icon": "scaleX(-1)" }}
              />
            </Space>
          </Group>
        </>
      }
      destroyOnClose={true}
      width={1200}
      open={open}
      onClose={() => {
        setOpen(false)
        setLead(null)
      }}
      maskClosable={false}
      maskStyle={{ display: "none" }}
      headerStyle={{ border: "none", paddingBottom: 0 }}
      bodyStyle={{ paddingTop: 0 }}
      footerStyle={{ display: "none" }}
    >
      <TsrComponent
        lead={lead?.lead}
        client={client}
        activeKey={activeKey}
        setActiveKey={setActiveKey}
        buttonText={buttonText}
        setButtonText={setButtonText}
        isFromAction={isFromAction}
        setIsFromAction={setIsFromAction}
      />
    </Drawer>
  )
}
export default TsrDrawer
